import "./common/header"

/**
 * Analytics events
 */

window.dataLayer = window.dataLayer || [];
function gtag(){
    dataLayer.push(arguments);
}

(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
'//www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
})(window,document,'script','dataLayer','GTM-MM66JW');

gtag('js', new Date());
gtag('config', 'G-S55V6YEM89');

const sentViews = new Set();
document.querySelectorAll('.eventAnalytics').forEach(function(el){
    const label = el.getAttribute('data-lab');
    if (label && !sentViews.has(label)) {
        gtag('event', 'visualização', {
            'event_category': 'desktop',
            'event_label': label
        });
        sentViews.add(label);
    }
});

document.addEventListener('click', function(e) {
    const el = e.target.closest('.eventAnalytics');
    if (el) {
        gtag('event', 'clique', {
            'event_category': el.getAttribute('data-cat'),
            'event_label': el.getAttribute('data-lab')
        });
    }
});

if ( 'undefined' != typeof window.COMPANY ) {
    gtag('event', 'acesso', {
        'event_category': 'desktop',
        'event_label': window.COMPANY
    });
}
